import { render, staticRenderFns } from "./filterProduct.vue?vue&type=template&id=3b6b0ac7&scoped=true&"
import script from "./filterProduct.vue?vue&type=script&lang=js&"
export * from "./filterProduct.vue?vue&type=script&lang=js&"
import style0 from "./filterProduct.vue?vue&type=style&index=0&id=3b6b0ac7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6b0ac7",
  null
  
)

export default component.exports